import Highcharts from "highcharts";
import { mapGetters } from "vuex";

const chartMixin = {
  computed: {
    ...mapGetters("pondDetails", {
      getCurrentCulture: "getCurrentCulture",
      pondId: "getSelectedPondId",
      getSelectedPond: "getSelectedPondWithDeviceDetails",
      calculatedTimezone: "getUserTimeZoneOffset",
    }),
    getHarvestId() {
      return (
        this.getCurrentCulture || {
          harvest_id: 0,
        }
      ).harvest_id;
    },
    getCultureDateRange() {
      return [
        this.getCurrentCulture.start_date,
        this.getCurrentCulture.end_date,
      ];
    },
    getMomentObjArrOfCultureDateRange() {
      const start_date = this.$moment.utc(this.getCultureDateRange[0]);
      const end_date = this.$moment.utc(this.getCultureDateRange[1]);
      return [start_date, end_date];
    },
    dateFormat() {
      return "YYYY-MM-DD";
    },
    getCurrLang() {
      return this.$i18n.locale;
    },
  },
  watch: {
    getHarvestId: {
      handler: function(newHarvestId, oldHarvestId) {
        if (newHarvestId === 0) {
          this.initDateRangeWithMomentObj(
            this.defaultMomentDtRangeForCurrCulture
          );
        } else {
          this.initDateRangeWithMomentObj(
            this.getMomentObjArrOfCultureDateRange
          );
        }
      },
      immediate: true,
    },
    pondId: async function() {
      await this.initComponent();
    },
    getCurrLang: function(newvalue, oldvalue) {
      this.$moment.locale(this.$i18n.locale);
      this.initChartLang();
    },
  },
  data: function() {
    return {
      xAxisTextKey: "Comn_feed",
      yAxisTextKey: "Comn_fcr",
    };
  },
  beforeCreate() {
    if (this != null) {
      const lang = {
        loading: this.$t("Comn_loading_pls_wait"),
        months: this.$moment.months(),
        noData: this.$t("Comn_no_data_connection"),
        numericSymbolMagnitude: 1000,
        rangeSelectorZoom: this.$t("Comn_zoom"),
        resetZoom: this.$t("Comn_reset_zoom"),
        resetZoomTitle: this.$t("Comn_reset_zoom_1_1"),
        shortMonths: this.$moment.monthsShort(),
        shortWeekdays: this.$moment.weekdaysShort(),
        weekdays: this.$moment.weekdays(),
      };
      Highcharts.setOptions({ lang });
    }
  },
  mounted() {
    this.$moment.locale(this.$i18n.locale);
  },
  methods: {
    disableDateMethod: function(time) {
      const isSelectedTimeBetweenCultureDate = this.$moment(
        time.getTime()
      ).isBetween(
        this.$lodash
          .cloneDeep(this.getMomentObjArrOfCultureDateRange[0])
          .subtract(1, "days"),
        this.getMomentObjArrOfCultureDateRange[1]
      );
      return !isSelectedTimeBetweenCultureDate;
    },
    initDateRangeWithMomentObj(momentDateArr) {
      const dates = momentDateArr;
      this.$set(this.dateRange, 0, dates[0].format(this.dateFormat));
      this.$set(this.dateRange, 1, dates[1].format(this.dateFormat));
      this.handleValueChange(this.dateRange);
    },
    checkDateWithInCultureRange(momentDateObj) {
      return momentDateObj.isBetween(
        ...this.getMomentObjArrOfCultureDateRange,
        "[]",
        "minutes"
      );
    },
    initChartStrings() {
      const lang = {
        loading: this.$t("Comn_loading_pls_wait"),
        months: this.$moment.months(),
        noData: this.$t("Comn_no_data_connection"),
        numericSymbolMagnitude: 1000,
        rangeSelectorZoom: this.$t("Comn_zoom"),
        resetZoom: this.$t("Comn_reset_zoom"),
        resetZoomTitle: this.$t("Comn_reset_zoom_1_1"),
        shortMonths: this.$moment.monthsShort(),
        shortWeekdays: this.$moment.weekdaysShort(),
        weekdays: this.$moment.weekdays(),
      };
      Highcharts.setOptions({ lang });
    },
    initChartLang() {
      // console.log(this.$moment.weekdaysShort());
      this.initChartStrings();
      this.setAxisText();
      this.initChart();
    },
    setAxisText() {
      this.chartOptions.xAxis.title.text = this.$t(this.xAxisTextKey);
      this.chartOptions.yAxis.title.text = this.$t(this.yAxisTextKey);
    },
    initAxisTextKeys(xAxisTextKey, yAxisTextKey) {
      this.xAxisTextKey = xAxisTextKey;
      this.yAxisTextKey = yAxisTextKey;
    },
  },
};
export default chartMixin;
